// /** @typedef {InstanceType<typeof import("../nshop-orders.model").NshopOrder>} $NshopOrder */
/** @typedef {import("../nshop-orders.inits").NshopOrder} $NshopOrder */

import { NSHOP_ORDER_PAYMENT_METHODS } from "../nshop-orders.const";

export class NshopOrderAider {
    /**
     * 최대수량 계산
     * @param {$NshopOrder} data
     */
    static calcCountMax(data) {
        switch (data?.payment?.method) {
            case "card": {
                return Math.floor((1000000 - 35000) / data?.price?.unit);
            }

            case "openbank": {
                return Math.floor(500000 / data?.price?.unit);
            }

            default: {
                return Math.floor(2000000 / data?.price?.unit);
            }
        }
    }
    /**
     * 전체금액 계산
     * @param {$NshopOrder} data
     */
    static calcPrice(data) {
        let price = { ...data.price };

        price.sum = this.calcPriceSum(data);
        price.fee = this.calcPriceFee(data, price.sum);
        price.sale = this.calcPriceSale(data, price.sum, price.fee);

        return price;
    }

    /**
     * 소계금액 계산
     * @param {$NshopOrder} data
     */
    static calcPriceSum(data) {
        return data.price.unit * data.count;
    }

    /**
     * 수수료 계산
     * @param {$NshopOrder} form
     * @param {number} [sum]
     */
    static calcPriceFee(form, sum) {
        switch (form.payment.method) {
            case "card": {
                if (!sum) sum = this.calcPriceSum(form);
                return sum * 0.035;
            }
            default: {
                return 0;
            }
        }
    }

    /**
     * 판매가 계산
     * @param {$NshopOrder} form
     * @param {number} [sum]
     * @param {number} [fee]
     */
    static calcPriceSale(form, sum, fee) {
        if (!sum) sum = this.calcPriceSum(form);
        if (!fee) fee = this.calcPriceFee(form);
        return sum - fee;
    }

    /**
     * 유효성 검사
     * @param {$NshopOrder} data
     */
    static async test(data) {
        if (!data.payment.method) throw new Error("결제수단을 선택하세요");

        let paymentMethodError = !NSHOP_ORDER_PAYMENT_METHODS[data.payment.method]?.uses;
        if (paymentMethodError) throw new Error("결제 수단이 잘못되었습니다");

        if (![10000, 30000, 50000].includes(data.price.unit)) throw new Error("권종이 잘못되었습니다");

        ////////////////////////////////////////////////////////////////////////
        // 수량은 1 이상의 정수여야 한다.
        // count 는 나누리 발급요청의 quantity 로 그대로 넘어가는데, 소수점이
        // 섞이면 상대 쪽이 소수점을 버리고 발급한다. 반면 금액검증(unit * count)은
        // 소수끼리 앞뒤가 맞아떨어져 그대로 통과하므로, 결제만 12만원 되고 핀은
        // 10만원어치만 나가는 차액 사고가 난다.
        // (2026-08-20 주문 2608201458310794, count=2.4 → 5만원권 2장 발급)
        // 입력창(v-model)을 거쳐 문자열로 들어오는 경로가 있어 숫자로 바꿔 검사한다.
        ////////////////////////////////////////////////////////////////////////
        let count = Number(data.count);
        if (!Number.isInteger(count)) throw new Error("구매 수량이 잘못되었습니다");

        let countMax = this.calcCountMax(data);
        if (countMax < count) throw new Error("구매 수량이 잘못되었습니다");

        if (count < 1) throw new Error("구매 수량이 잘못되었습니다");

        let price = this.calcPrice(data);

        let priceError = Object.entries(price).some(([key, value]) => data.price[key] !== value);
        if (priceError) throw new Error("구매 금액이 잘못되었습니다");
    }
}
